import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="19" height="21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M0 0h7v20.974H0V0zm12 0h7v20.974h-7V0z" fill="#666" /></svg>;